import { TermsOfService } from "@/components/common/TermsOfService";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute('/fr/cookies')({
  component: () => TermsOfService({ pdfPath: '/COOKIES_FR.pdf' }),
});